import { ReactComponent as ProductDescriptionItemOne } from "./../assets/svgs/product-description-item-one.svg";
import { ReactComponent as ProductDescriptionItemTwo } from "./../assets/svgs/product-description-item-two.svg";
import { Link } from "react-router-dom";

const ImageCardDetails = ({
  title,
  description,
  source,
  linkTextOne,
  linkTextTwo,
}) => {
  const matchHeightClass =
    source === "integration"
      ? "min-h-[calc(300px)] md:min-h-[calc(450px)]"
      : "min-h-[calc(350px)] md:min-h-[calc(500px)]";
  return (
    <div className={`max-w-[520px] h-full flex flex-col ${matchHeightClass}`}>
      <div className="font-sans font-normal text-[12px] leading-[14.4px] tracking-[0.17px] align-middle uppercase text-[#1A1A1A]">
        Use Cases
      </div>

      <div className="mt-[16px] text-[24px] leading-[24px] md:text-[32px] md:leading-[40px] tracking-[-0.96px] text-black font-normal">
        {title}
      </div>

      <p className="mt-[20px] text-[14px] leading-[23.4px] tracking-[0.17px] align-middle text-[#1A1A1A] max-w-[440px] font-normal">
        {description}
      </p>

      <div className="md:mt-auto mt-0 py-[33px] space-y-5">
        <div className="my-[20px] space-y-2 flex flex-col">
          <div className="flex flex-row gap-[10px] md:items-start">
            <div className="w-[18px] h-[18px]">
              <ProductDescriptionItemOne />
            </div>

            <a
              href="#"
              className="font-[1000] text-[13px] leading-[23.4px] tracking-[0.17px] align-middle underline decoration-solid text-[#47423D] hover:text-black"
            >
              {linkTextOne}
            </a>
          </div>
          <div className="flex flex-row gap-[10px] md:items-start">
            <div className="w-[18px] h-[18px]">
              <ProductDescriptionItemTwo />
            </div>
            <a
              href="#"
              className="font-[1000] text-[13px] leading-[23.4px] tracking-[0.17px] align-middle underline decoration-solid text-[#47423D] hover:text-black"
            >
              {linkTextTwo}
            </a>
          </div>
        </div>

        <Link to="/get-started">
          <button
            type="button"
            className="text-[15px] inline-flex items-center justify-center w-[124px] h-[36px] md:h-[40px] rounded-[8px] px-[20px] py-[12.6px] border border-black bg-white text-black whitespace-nowrap transition-colors duration-200 hover:bg-black hover:text-white"
          >
            Get Started
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ImageCardDetails;
